import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Typography from '@material-ui/core/Typography';
import {useTranslation} from "react-i18next";
import {makeStyles} from "@material-ui/core/styles/index";
import UserAvatar from "../../../user-avatar/UserAvatar";
import Hidden from '@material-ui/core/Hidden';
import {Guests} from "./Guests";
import Chip from "@material-ui/core/Chip";
import {Guest} from "../../../../models/pro-guest.models";
import {ChipBackgroundColors, ChipTextColors} from "../../../../layout/_constants";

const useStyles = makeStyles(theme => ({
    root: {
        height: 'auto',
        flexGrow: 1,
        maxWidth: 700,
    },
    actionColumn: {
        maxWidth: 150,
        width: 100
    },
    avatarColumn: {
        maxWidth: 70,
        width: 70
    }
}));

interface GuestsBrowserSimpleProps {
    organizationId: number;
    folderId?: number | string;
    groupId?: number | string;
    refresh?: number;
    onlyPending?: boolean;
    actionsRender?: (g: Guest) => JSX.Element;
}

export const GuestsBrowserSimple: React.FC<GuestsBrowserSimpleProps> = ({
                                                                            actionsRender,
                                                                            ...properties
                                                                        }) => {
    const {t} = useTranslation();
    const classes = useStyles();

    const row = (guest: Guest) => <TableRow key={guest.userId}>
        <TableCell component="th" scope="row" className={classes.avatarColumn}>
            <UserAvatar userId={guest.userId}/>
        </TableCell>
        <TableCell>
            <Typography variant="body1">{guest.firstName} {guest.lastName}</Typography>
            <Typography variant="body2"
                        color={'textPrimary'}>{guest.email}</Typography>
        </TableCell>
        <TableCell>
            {
                guest.isEnabled === undefined ?
                    <Chip
                        color='primary'
                        style={{backgroundColor: ChipBackgroundColors.Disabled, color: ChipTextColors.Disabled}}
                        label={t('ProGuest.Guests.Table.Status.Pending')}/> : guest.isEnabled === true ?
                        <Chip
                            color='primary'
                            style={{backgroundColor: ChipBackgroundColors.Default, color: ChipTextColors.Default}}
                            label={t('ProGuest.Guests.Table.Status.Accepted')}/> :
                        <Chip
                            color='primary'
                            style={{backgroundColor: ChipBackgroundColors.Expired}}
                            label={t('ProGuest.Guests.Table.Status.Declined')}/>
            }
        </TableCell>
        {
            !!actionsRender &&
            <TableCell className={classes.actionColumn} align="center">
                {actionsRender(guest)}
            </TableCell>
        }
    </TableRow>;

    const header = <TableRow>
        <TableCell className={classes.avatarColumn}></TableCell>
        <TableCell>{t('ProGuest.Guests.Table.Headers.User')}</TableCell>
        <TableCell>{t('ProGuest.Guests.Table.Headers.Status')}</TableCell>
        {
            !!actionsRender &&
            <TableCell className={classes.actionColumn}></TableCell>
        }
    </TableRow>;

    return <Guests
        {...properties}
        headerRender={() => header}
        rowRender={row}
    />;
};
